/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Returns standard image URLs, preserving clean paths and handling native Unsplash parameters.
 *
 * @param url The source image URL
 * @param width Optional width in pixels (for Unsplash native sizing)
 * @param quality Optional quality score (for Unsplash native compression)
 */
export function getOptimizedImageUrl(url: string, width?: number, quality: number = 75): string {
  if (!url) return "";

  // Guard against base64/inline data URLs
  if (url.startsWith("data:")) {
    return url;
  }

  // If the URL is an Unsplash image, adjust native parameters directly
  if (url.includes("images.unsplash.com")) {
    const baseUrl = url.split("?")[0];
    const widthParam = width ? `&w=${width}` : "";
    return `${baseUrl}?auto=format&fit=crop&q=${quality}${widthParam}`;
  }

  // Clean production absolute URLs to be served relatively
  if (url.startsWith("https://www.razoravan.linkpc.net/")) {
    return url.replace("https://www.razoravan.linkpc.net", "");
  }

  return url;
}

